const css = `._8GT-kW__disabled{opacity:.5}._8GT-kW__tooltipContainer{text-overflow:ellipsis;white-space:nowrap;overflow:hidden}._8GT-kW__tooltipContainer:after{content:"";display:block}._8GT-kW__table{min-width:800px}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};

export default {"tooltipContainer":"_8GT-kW__tooltipContainer","disabled":"_8GT-kW__disabled","table":"_8GT-kW__table"};
